import React, { useState, useEffect } from "react";
import { Navigation, Bookmark, Eye, Search } from "lucide-react";
import { backendApi } from "@/api/backendApi";

export default function MyJobActivityWidget() {
    const [analytics, setAnalytics] = useState({
        applicationAnalytics: { total: 0 },
        savedJobsCount: 0,
        recruiter_views: 0,
        profile_searches: 0
    });
    const [loading, setLoading] = useState(true);

    const fetchAnalytics = () => {
        if (!backendApi.auth.getToken()) {
            setLoading(false);
            return;
        }
        backendApi.entities.Dashboard.analytics()
            .then(data => {
                setAnalytics(data);
                setLoading(false);
            })
            .catch(() => {
                setAnalytics({
                    applicationAnalytics: { total: 0 },
                    savedJobsCount: 0,
                    recruiter_views: 0,
                    profile_searches: 0
                });
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchAnalytics();
        const interval = setInterval(fetchAnalytics, 30000);
        return () => clearInterval(interval);
    }, []);

    const cards = [
        {
            id: "applied",
            label: "Applied Jobs",
            count: analytics.applicationAnalytics?.total || 0,
            color: "blue",
            icon: <Navigation className="w-5 h-5 text-blue-500 mb-2" />,
            bg: "bg-blue-50",
        },
        {
            id: "saved",
            label: "Saved Jobs",
            count: analytics.savedJobsCount || 0,
            color: "purple",
            icon: <Bookmark className="w-5 h-5 text-purple-500 mb-2" />,
            bg: "bg-purple-50",
        },
        {
            id: "recruiter_views",
            label: "Recruiter Views",
            count: analytics.recruiter_views || 0,
            color: "green",
            icon: <Eye className="w-5 h-5 text-green-500 mb-2" />,
            bg: "bg-green-50",
        },
        {
            id: "profile_searches",
            label: "Profile Searches",
            count: analytics.profile_searches || 0,
            color: "orange",
            icon: <Search className="w-5 h-5 text-orange-500 mb-2" />,
            bg: "bg-orange-50",
        },
    ];

    return (
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 mb-6">
            <h3 className="text-gray-900 font-semibold mb-4">My Job Activity</h3>
            {loading ? (
                <div className="p-4 text-center text-gray-500 font-medium">Loading...</div>
            ) : (
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
                    {cards.map((card) => (
                        <div
                            key={card.id}
                            className={`rounded-xl p-4 flex flex-col items-center justify-center border border-gray-100 cursor-pointer hover:shadow-md transition-shadow ${card.bg}`}
                        >
                            {card.icon}
                            <div>
                                <h3 className={`text-2xl font-bold text-${card.color}-600 text-center`}>
                                    {card.count}
                                </h3>
                                <p className="text-sm text-gray-500 mt-1">{card.label}</p>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
